import { atom } from 'nanostores';

export type AppMode = 'game' | 'scene-editor' | 'auto-battle';

// default to auto-battle to align with GameSceneConfig defaultMode
export const appMode = atom<AppMode>('game');

export function setAppMode(mode: AppMode) {
  appMode.set(mode);
}
